import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react";

import { useStore } from "../../store";
import { IProject } from "../../store/feedStoreTypes";
import { getProjectDetail } from "../../api";
import { languageAr } from "../../utils/Translation";
import { DetailContainer } from "./style";
import DetailItemView from "./DetailItemView";

interface Props {
  projectId: string;
}
const DetailItem = ({ projectId }: Props) => {
  const {
    appStore: {
      apiHeaderState: { token, language },
    },
  } = useStore();
  const { id } = useParams<{ id: string }>();

  const { isAr } = languageAr(language);
  const [project, setProject] = useState<null | IProject>(null);
  const setLikeCount = (count: number) => {
    if (!project) return null;
    setProject({ ...project, likeCounts: count });
  };

  const onGetProjectDetail = () => {
    getProjectDetail({ token, language, projectId }).then((resp) => {
      setProject(resp.data);
    });
  };

  useEffect(onGetProjectDetail, []);

  return (
    <DetailContainer>
      <DetailItemView
        id={id}
        isAr={isAr}
        project={project}
        setLikeCount={setLikeCount}
      />
    </DetailContainer>
  );
};

export default observer(DetailItem);
